import React from 'react';
import { Route } from '../Routing/types';
import { CookbookPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/meals/cookbook/*',
    element: <CookbookPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: dummy_t('meals.navbarTitle'),
    mobileAppTabIdentifier: 'diet',
    descendantRoutes: descendantRoutes,
  },
];

export default routes;
